import { render } from "./AddItemPage.vue?vue&type=template&id=f19e1a56"
import script from "./AddItemPage.vue?vue&type=script&lang=js"
export * from "./AddItemPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__